import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="catalog--search"
export default class extends Controller {
  query = "";
  timeout = null;

  static targets = ["frame"];

  connect() {
    this.query = "";
    clearTimeout(this.timeout);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  debounce({ target }) {
    this.query = target.value;

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.updateSearch();
    }, 325);
  }

  async updateSearch() {
    let url = new URL(window.location.href);
    url.searchParams.delete("page");
    url.searchParams.set("query", this.query);
    this.frameTarget.src = url.toString();
  }
}
